<template>
  <div>
    <section class="form">
      <card-component title="Load Wonde Schools" icon="ballot">
        <div>
          Select a project
        </div>
        <div>
          <hr />
          <div class="selector-container">
            <p class="project">Project</p>
            <b-select
              placeholder="Select a project"
              v-model="selectedProjects.project"
              required
            >
              <option
                v-for="(project, index) in projects"
                :key="index"
                :value="project.project"
              >
                {{ project.project }}
              </option>
            </b-select>
          </div>
        </div>
        <div>
        <b-field grouped class="add-lock-and-english">
          <b-field label="Add English?">
            <div class="is-justify-content-start subject">
              <b-checkbox :value="true" :disabled="true" native-value="Maths">
                Maths
              </b-checkbox>

              <b-checkbox native-value="English" v-model="addEnglish">
                English
              </b-checkbox>
            </div>
          </b-field>

          <b-field class="lockJourney">
            <div class="is-flex-direction-column">
              <p class="toggleTitle">Enable lock Journey?</p>
              <b-switch
                class="toggleSwitch"
                v-model="isLockJourneyActive"
                true-value="Yes"
                false-value="No"
              >
              </b-switch>
            </div>

            <div
              class="is-justify-content-start new-lock-journey"
              v-if="isLockJourneyActive == 'Yes'"
            >
              <b-checkbox
                :disabled="catchup"
                v-model="assessment"
                native-value="assessment"
              >
                Assessment
              </b-checkbox>
              <b-checkbox
                :disabled="assessment"
                native-value="catchup"
                v-model="catchup"
              >
                Catchup
              </b-checkbox>
            </div>
          </b-field>
        </b-field>

        <b-field label="Language" class="learner-local">
          <b-select
            class="editBox row-selection"
            :disabled="local.length === 0"
            v-model="learnerLanguage"
          >
            <option
              v-for="(option, index) in local"
              :value="option"
              :key="index"
            >
              {{ option }}
            </option>
          </b-select>
        </b-field>

        <div class="select-school">
            <b-field label="schools" horizontal class="field">
              <b-select
                placeholder="Select a school"
                v-model="schoolIndex"
                @input="populateSchool(schoolIndex)"
                required
              >
                <option
                  v-for="(school, index) in getWondeSchools"
                  :key="index"
                  :value="index"
                >
                  {{ school.name }}
                </option>
              </b-select>
            </b-field>
        </div>
      </div>

       

      </card-component>
    </section>
    <section class="form" v-if="collection">
      <card-component title="List of learners" icon="ballot">
        <div class="container-list">
          <p>
            Wonde has returned
            <strong>{{ fullCollection.length }}</strong> students registered
            within {{ this.getWondeSchools[this.schoolIndex].name }}.
          </p>
          <p v-if="!this.filterGrade">
            Please <strong>select a grade</strong> to view the students.
          </p>
          <p v-if="this.filterGrade">
            Grade <strong>{{ filterGrade }}</strong> returned
            <strong>{{ this.collection.length }}</strong> students.
          </p>
          <p v-if="selectedStudents.length">
            <strong>{{ selectedStudents.length }}</strong> learners selected for
            import.
          </p>

          <span class="select is-primary">
            <b-select
              placeholder="Select a grade"
              v-model="filterGrade"
              class="is-primary"
            >
              <option
                v-for="(grade, index) in this.gradeOptions"
                :key="index"
                :value="grade"
              >
                {{ grade }}
              </option>
            </b-select>
          </span>
          <b-table
            v-if="collection && filterGrade"
            class="table"
            :bordered="true"
            :striped="true"
            :narrowed="true"
            :data="collection"
            :columns="columns"
            checkable
            :checked-rows.sync="selectedStudents"
            :checkbox-position="checkboxPosition"
            :checkbox-type="checkboxType"
          >
          </b-table>
          <b-message
            v-if="submitMessage"
            title="Submission Results"
            :type="submitMessage.submitted ? 'is-info' : 'is-danger'"
          >
            <span v-for="text in submitMessage.message.split('$$')" :key="text">
              <div v-if="checkText(text)" style="color:#FFA500">
                {{ text.replace(",", " ") }}
              </div>
              <div v-else>
                {{ text.replace(",", " ") }}
              </div>
              <br />
            </span>
          </b-message>
          <br />
          <b-field grouped class="btn-group" v-if="collection && filterGrade">
            <div class="control">
              <b-button
                type="is-primary is-success is-outlined"
                @click="reset()"
                v-html="'Reset Selection'"
              />
            </div>
            <div class="control">
              <b-button
                type="is-primary is-success"
                @click="submitStudents()"
                v-html="'Register Learners'"
              />
            </div>
          </b-field>
        </div>
      </card-component>
    </section>
  </div>
</template>

<script>
import CardComponent from "@/components/CardComponent";
import { mapState, mapActions } from "vuex";

export default {
  name: "WondeImportComponent",
  components: {
    "card-component": CardComponent
  },
  data() {
    return {
      selectedProjects: {
        project: null
      },
      isLoading: false,
      schoolIndex: null,
      showLearners: false,
      catchup: false,
      assessment: false,
      addEnglish: false,
      lockJourney: null,
      isLockJourneyActive: "No",
      getWondeSchools: [],
      schoolId: null,
      collection: null,
      fullCollection: null,
      filterGrade: null,
      gradeOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, "R"],
      selectedStudents: [],
      checkboxPosition: "left",
      checkboxType: "is-primary",
      resetData: false,
      submitMessage: null,
      local: [],
      learnerLanguage: null,
      subject: "MATHS",
      form: {
        subscriptionDate: null,
        content: null,
      },
      submittedMessage: {
        submit: false,
        message: null
      },
      submitted: false,
      columns: [
        {
          field: "firstName",
          label: "First Name",
          width: "20"
        },

        {
          field: "lastName",
          label: "Last Name",
          width: "20"
        },
        // {
        //   field: "preferredName",
        //   label: "Preferred Name",
        //   width: "20"
        // },
        {
          field: "grade",
          label: "Grade",
          width: "20"
        },
        // {
        //   field: "class",
        //   label: "Class",
        //   width: "20"
        // },
        {
          field: "email",
          label: "Email",
          width: "20"
        },
        {
          field: "gender",
          label: "Gender",
          width: "20"
        },
        {
          field: "studentNumber",
          label: "Student Number",
          width: "20"
        },
        {
          field: "password",
          label: "Password",
          width: "20"
        },
        {
          field: "project",
          label: "Project",
          width: "20"
        },
        // {
        //   field: "school",
        //   label: "School",
        //   width: "20"
        // },
        {
          field: "language",
          label: "Language",
          width: "40"
        },
        {
          field: "subject",
          label: "Subject",
          width: "20"
        },
        {
          field: "lockedJourneys",
          label: "locked Journeys",
          width: "20"
        }
      ]
    };
  },
  computed: {
    ...mapState({
      projects: state => state.globalStore.projects,
      projectStructure: state => state.adminStore.projectStructure
    })
  },
  async mounted() {
    this.loading(true);
    this.getWondeSchools = await this.fetchWondeSchool();
    this.loading(false);
    this.local.push("English");
    this.local.push("Afrikaans")
  },
  methods: {
    ...mapActions({
      fetchWondeSchool: "adminStore/fetchWondeSchool",
      addEnglishAndLockJourney: "adminStore/addEnglishAndLockJourney",
      loading: "SET_SCREEN_LOADING",
      fetchStudents: "adminStore/fetchStudents",
      submitLearners: "adminStore/submitLearners"
    }),
    resetTable(event) {
      this.showLearners = event;
    },
    async populateSchool() {
      this.collection = null;
      this.submitMessage = null;
      this.loading(true);
      await this.loadLearners();
      this.loading(false);
    },
    async loadLearners() {
      this.lockJourney = "";
      //lockedJourneys
      if (this.catchup || this.assessment) {
        if (this.catchup) {
          this.lockJourney = "catchup";
        }
        if (this.assessment) {
          this.lockJourney = "assessment";
        }
      }

      if (this.isLockJourneyActive != "Yes") {
        this.lockJourney = "";
        this.catchup = false;
        this.assessment = false;
      }

      //adding english
      this.subject = "MATHS";
      if (this.addEnglish) {
        this.subject += "|ENGLISH";
      }
      let school = {
        project: this.selectedProjects.project,
        id: this.getWondeSchools[this.schoolIndex].id,
        name: this.getWondeSchools[this.schoolIndex].name,
        lockJourney: this.lockJourney,
        language: this.learnerLanguage,
        subjects: this.subject,
        pageLimit: 200,
        pageNumber: 1
      };

      let response = [];
      let hasNextPage = true;
      do {
        let eachResponse = await this.fetchStudents(school);
        //concat each response
        let entireSet = response;
        let newSet = eachResponse.students;
        response = entireSet.concat(newSet);
        if (eachResponse && eachResponse.pagination.more == false) {
          hasNextPage = false;
        }
        school.pageNumber++;
        //safety catch, avoid too many calls
        if (school.pageNumber > 2) {
          hasNextPage = false;
        }
      } while (hasNextPage);

      this.collection = response;
      this.fullCollection = response;
      this.loading(false);

      if (!this.collection) {
        this.$buefy.toast.open({
          message: "Importing learners failed!.",
          type: "is-danger",
          duration: 5000
        });
      }
      this.$buefy.toast.open({
        message:
          "Successfully found " +
          this.collection.length +
          "  learners, please filter them by grade.",
        type: "is-danger",
        duration: 5000
      });
    },
    async submitStudents() {
      this.submit = true;
      this.loading(true);
      this.form.content = this.selectedStudents;
      this.form.subscriptionDate = this.getSubscriptiondate();
      this.submitMessage = await this.submitLearners(this.form);
      this.loading(false);
    },
    reset() {
      this.collection = null;
      this.submitMessage = null;
      this.$emit("resetData", this.resetData);
    },
    getSubscriptiondate() {
      let subscriptionDate = new Date(
        new Date().setFullYear(new Date().getFullYear() + 1)
      );
      return (
        subscriptionDate.getMonth() +
        "/" +
        subscriptionDate.getDate() +
        "/" +
        subscriptionDate.getFullYear()
      );
    },
    checkText(val) {
      return val.includes(this.errorMessage);
    }
  },
  watch: {
    filterGrade: {
      handler: function(grade) {
        let filteredCollection = [];
        for (let i = 0; i < this.fullCollection.length; i++) {
          if (this.fullCollection[i].grade == grade) {
            filteredCollection.push(this.fullCollection[i]);
          }
        }
        this.collection = filteredCollection;
        this.selectedStudents = [];
      }
    }
  }
};
</script>
<style lang="scss">
.toggleSwitch {
  display: contents;
}
.toggleTitle {
  margin-right: 0.5rem;
  font-weight: 700;
}
.field {
  .has-addons {
    display: block;
  }
}
.is-flex-direction-column {
  display: flex;
  flex-direction: row;
}
.subject {
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}
.lockJourney {
  margin-left: 6rem;
}
.add-lock-and-english {
  margin-top: 1.2rem;
  margin-bottom: 3rem;
}

.learner-local {
  display:flex; 
  gap:1rem; align-items: center; 
  margin-top:1.8rem
}

.schools-dropdown {
  margin-left: -12rem;
}

.field.is-grouped {
  flex-direction: row;
}

.is-justify-content-start {
    &.new-lock-journey {
      margin-left: 0 !important;
      display: flex;
      margin-top: 1rem;
    }
}

.selector-container {
  display: flex;
  justify-content: flex-start;
  align-content: flex-start;

  p {
    margin-top: 0.4rem;
    font-weight: 700;
  }
  .control {
    margin-left: 1rem;
  }
}
.select-school {
  display: flex;
}
</style>
